import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Toaster } from 'sonner';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import { Navbar } from './components/Navbar';
import { LanguageSelect } from './pages/LanguageSelect';
import { Landing } from './pages/Landing';
import { Auth } from './pages/Auth';
import { Marketplace } from './pages/Marketplace';
import { PaymentFlow } from './pages/PaymentFlow';
import { AdminLogin } from './pages/AdminLogin';
import { AdminDashboard } from './pages/AdminDashboard';
import { ChatPage } from './pages/ChatPage';
import { Profile } from './pages/Profile';
function ProtectedAdminRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    isAdmin
  } = useAuth();
  if (!isAdmin) return <Navigate to="/admin/login" replace data-id="element-0" />;
  return <>{children}</>;
}
function AppContent() {
  const {
    hasSelectedLanguage
  } = useLanguage();
  if (!hasSelectedLanguage) {
    return <LanguageSelect data-id="element-1" />;
  }
  return <BrowserRouter data-id="element-2">
      <div className="flex flex-col min-h-screen w-full bg-background text-foreground" data-app="theo-edumarket" data-id="element-3">
        <Navbar data-id="element-4" />
        <main className="flex-1 flex flex-col" data-id="element-5">
          <AnimatePresence mode="wait" data-id="element-6">
            <Routes data-id="element-7">
              <Route path="/" element={<Landing data-id="element-9" />} data-id="element-8" />
              <Route path="/auth" element={<Auth data-id="element-11" />} data-id="element-10" />
              <Route path="/marketplace" element={<Marketplace data-id="element-13" />} data-id="element-12" />
              <Route path="/payment/:fileId" element={<PaymentFlow data-id="element-15" />} data-id="element-14" />
              <Route path="/chat" element={<ChatPage data-id="element-17" />} data-id="element-16" />
              <Route path="/profile" element={<Profile data-id="element-19" />} data-id="element-18" />
              <Route path="/admin/login" element={<AdminLogin data-id="element-21" />} data-id="element-20" />
              <Route path="/admin/dashboard" element={<ProtectedAdminRoute data-id="element-23">
                    <AdminDashboard data-id="element-24" />
                  </ProtectedAdminRoute>} data-id="element-22" />
              <Route path="*" element={<Navigate to="/" replace data-id="element-26" />} data-id="element-25" />
            </Routes>
          </AnimatePresence>
        </main>
      </div>
      <Toaster position="top-right" richColors closeButton data-id="element-27" />
    </BrowserRouter>;
}
export function App() {
  return <ThemeProvider data-id="element-28">
      <LanguageProvider data-id="element-29">
        <AuthProvider data-id="element-30">
          <DataProvider data-id="element-31">
            <AppContent data-id="element-32" />
          </DataProvider>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>;
}